import { StyleSheet } from 'react-native';

import { isBigScreen } from '../media-query';

export default StyleSheet.create({
  container: {
    height: '100%',
    justifyContent: 'center',
  },
  modalContent: {
    maxHeight: isBigScreen() ? 400 : '100%',
    height: isBigScreen() ? 'auto' : '100%',
    width: '100%',
    maxWidth: 800,
    alignSelf: 'center',
    overflow: 'hidden',
    borderRadius: isBigScreen() ? 8 : 0,
  },
  backButton: {
    padding: 12,
  },
});
